import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class RangeSliderViewModel extends ControlViewModel {
    public lowerBoundary: KnockoutObservable<number>;
    public upperBoundary: KnockoutObservable<number>;
    public min: number;
    public max: number;
    public kTooltip: any;
    public smallStep: number;
    public largeStep: number;
    public tickPlacement: string;
    public markers: any;
    public values: KnockoutComputed<Array<number>>;

    /**
     * Das ViewModel für den RangeSlider
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.lowerBoundary = this.observableOrDefault(params.lowerBoundary, 0);
        this.upperBoundary = this.observableOrDefault(params.upperBoundary, 0);
        this.min = this.paramOrDefault(params.min, 0);
        this.max = this.paramOrDefault(params.max, 10);
        this.kTooltip = this.paramOrDefault(params.kTooltip, null);
        this.smallStep = this.paramOrDefault(params.smallStep, 1);
        this.largeStep = this.paramOrDefault(params.largeStep, 5);
        this.tickPlacement = this.paramOrDefault(params.tickPlacement, 'both');
        this.markers = this.paramOrDefault(params.markers, null);

        this.values = this.definePureComputed({
            read: () => {
                return [this.lowerBoundary(), this.upperBoundary()];
            },
            write: (values: any) => {
                this.lowerBoundary(values[0]);
                this.upperBoundary(values[1]);
            }
        });
    }

    public full(): void {
        this.lowerBoundary(this.min);
        this.upperBoundary(this.max);
    }

    public empty(): void {
        this.lowerBoundary(this.min);
        this.upperBoundary(this.min);
    }
}

ComponentManager.setViewModel('RangeSliderViewModel', RangeSliderViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');